<template>
  <div class="details-container">
    <ResponseMessage :type="messageType">{{ error }}</ResponseMessage>
    <AppStoreBanner />
    <VideoHero v-if="videoData" :video="videoData"></VideoHero>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import { handleApiError } from '@/scripts/shared-utils';
import axios from 'axios';
import AppStoreBanner from '@/components/AppStoreBanner.vue';
import ResponseMessage from '@/components/ResponseMessage.vue';
import VideoHero from '@/components/VideoHero.vue';

const route = useRoute();
const shortId = ref(null);
const videoData = ref(null);
const error = ref(null);

const messageType = computed(() => error.value ? "error" : "");

async function fetchVideoData() {
  error.value = null;
  
  try {
    const response = await axios.get(`/api/share/video/${shortId.value}`);
    videoData.value = response.data;
  } catch (err) {
    handleApiError(err, 'fetching shared video data');
    
    if (err.response && err.response.status === 404) {
      error.value = 'This link is invalid or expired. Please check with the person who shared it with you.';
    }
    
    videoData.value = null;
  }
}

onMounted(async () => {
  shortId.value = route.params.short_id;
  await fetchVideoData();
});
</script>

<style scoped>
@import '@/styles/shared-details.css';
</style>
